import { DataContract } from "./contracts/DataContract.js";

export class DataService extends DataContract {

    constructor(options = {}) {
        super();

        const {
            httpClient,
            resourcePath,
        } = options;

        if (!httpClient) throw new Error('DataService: "httpClient" is required.');
        if (!resourcePath) throw new Error('DataService: "resourcePath" is required.');

        this.http = httpClient;
        this.resourcePath = String(resourcePath).replace(/\/+$/, '');
        
    }

    async queryData(query = null) {
        const response = await this.http.get(this.resourcePath, query, {
            responseType: 'json',
        });
        return response.payload;
    }

    async readData(publicId) {
        const response = await this.http.get(this._detailPath(publicId), null, {
            responseType: 'json',
        });
        return response.payload;
    }

    async createData(data) {
        const response = await this.http.post(this.resourcePath, data, {
            contentType: 'json',
            responseType: 'json',
        });
        return response.payload;
    }

    async updateData(publicId, data) {
        const response = await this.http.put(this._detailPath(publicId), data, {
            contentType: 'json',
            responseType: 'json',
        });
        return response.payload;
    }

    async deleteData(publicId) {
        const response = await this.http.delete(this._detailPath(publicId), null, {
            responseType: 'json',
        });
        return response.payload;
    }

    _detailPath(publicId) {
        if (!publicId) throw new Error('DataService: "publicId" is required.');
        return `${this.resourcePath}/${encodeURIComponent(publicId)}`;
    }
}
